import uaUtils from '@/utils/uaUtils';

const SAFARI_MOBILE_NAME = 'Mobile Safari';
const CHROME_MOBILE_NAME = 'Mobile Chrome';
const CHROME_NAME = 'Chrome';
const EDGE_NAME = 'Edge';
const SAFARI_NAME = 'Safari';
const BRAVE_NAME = 'Brave';

const isIosChromeBrowser = () =>
    (uaUtils.getBrowserName() === CHROME_NAME || uaUtils.getBrowserName() === CHROME_MOBILE_NAME) && isIosDevice();

const isIosSafariBrowser = () => uaUtils.getBrowserName() === SAFARI_MOBILE_NAME && isIosDevice();

const isBluefyBrowser = () => !!navigator.userAgent.match(/Bluefy/i);

const isBraveBrowser = () => uaUtils.getBrowserName() === BRAVE_NAME;

const isChromeBrowser = () =>
    uaUtils.getBrowserName() === CHROME_NAME || uaUtils.getBrowserName() === CHROME_MOBILE_NAME;

const isEdgeBrowser = () => uaUtils.getBrowserName() === EDGE_NAME;

const isSafariBrowser = () =>
    uaUtils.getBrowserName() === SAFARI_NAME || uaUtils.getBrowserName() === SAFARI_MOBILE_NAME;

const isTabletDevice = () => {
    const isTablet = uaUtils.isTablet();

    if (isTablet) return true;

    if (isTabletIos()) return true;

    return isMultiTouchSupported();
};

const isTabletIos = () => {
    const isTouch = isTouchSupported();
    const isMac = uaUtils.isMac();

    if (isMac && isTouch) return true;

    return false;
};

const isIosDevice = () => {
    const isIos = uaUtils.isIos();

    if (isIos) return true;

    return isTabletIos();
};

const getUserAgent = () => navigator.userAgent;

const isInStandaloneMode = () => {
    if (window.navigator.standalone) {
        return true;
    }

    if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }

    return false;
};

const isExtensionsApiAvailable = () => !!window.chrome && !!window.chrome.runtime;

const isBrowserTrusted = () => {
    const edgeNotIos = isEdgeBrowser() && !isIosDevice();
    const isChrome = isChromeBrowser() && !!window.chrome;
    const isBrowserTrusted = (isBluefyBrowser() || isChrome || edgeNotIos) && !isBraveBrowser();

    if (uaUtils.isMobile()) {
        // Check mobile browser on extensions availability to avoid some mobile browsers
        return isBrowserTrusted && (edgeNotIos ? true : !isExtensionsApiAvailable());
    } else {
        return isBrowserTrusted;
    }
};

const onTouchStartEvent = 'ontouchstart';

const isTouchSupported = () => {
    return onTouchStartEvent in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints;
};

const isMultiTouchSupported = () => {
    return navigator.maxTouchPoints >= 5 || navigator.msMaxTouchPoints >= 5;
};

const isBluetoothSupported = () => !!navigator.bluetooth;

const isHidSupported = () => !!navigator.hid;

const IOS_STATIC_TOP_BAR_MAJOR_VERSION = 26;
const IOS_STATIC_TOP_BAR_MIN_MINOR_VERSION = 1;

const isStandaloneWithStaticTopBar = () => {
    if (!isIosDevice()) return false;
    if (!isInStandaloneMode()) return false;

    // in ios 26+ ios version is specified as browser version
    const osVersion = uaUtils.getBrowserVersion();
    const major = uaUtils.parseMajorVersion(osVersion);
    const minor = uaUtils.parseMinorVersion(osVersion) ?? 0;

    if (major > IOS_STATIC_TOP_BAR_MAJOR_VERSION) return true;
    if (major === IOS_STATIC_TOP_BAR_MAJOR_VERSION && minor >= IOS_STATIC_TOP_BAR_MIN_MINOR_VERSION) return true;
    return false;
};

export default {
    getUserAgent,
    isBluefyBrowser,
    isInStandaloneMode,
    isIosSafariBrowser,
    isIosChromeBrowser,
    isChromeBrowser,
    isEdgeBrowser,
    isSafariBrowser,
    isBrowserTrusted,
    isTouchSupported,
    isMultiTouchSupported,
    isBluetoothSupported,
    isHidSupported,
    isTabletDevice,
    isTabletIos,
    isIosDevice,
    isStandaloneWithStaticTopBar,
};
